import moment from 'moment'
import ft from '../featureToggle'

export default {
  getReviewStats  (VueApp, provId, callback) {
    let self = this
    VueApp.$sdk.get('/provider/' + provId + '/reviews/summary', {
      token: VueApp.$store.state.session.sessionToken
    }, res => {
      if (res.error) {
        callback(res)
        return
      }

      VueApp.$store.commit('provider/setAverageTotalReviews', {
        average: res.average,
        total: res.count
      })

      self.getFiveStarReviewsCount(VueApp, provId, callback)
    })
  },
  getFiveStarReviewsCount (VueApp, provId, callback) {
    VueApp.$sdk.get('/provider/' + provId + '/reviews', {
      token: VueApp.$store.state.session.sessionToken,
      value: 5
    }, res => {
      if (!res.error) {
        VueApp.$store.commit('provider/setFiveStarReview', res.list.length)
      }
      callback(res)
    })
  },
  getProviderReviews (VueApp, provId, callback) {
    let provider = VueApp.$store.state.provider
    let pageSize = provider.reviewsPerPage
    let page = provider.reviewPage

    VueApp.$sdk.get('/provider/' + provId + '/reviews', {
      token: VueApp.$store.state.session.sessionToken,
      pageSize: pageSize,
      pageNum: page + 1
    }, res => {
      if (!res.error) {
        VueApp.$store.commit('provider/setReviewPage', page + 1)

        if (res.list.length < pageSize) {
          VueApp.$store.commit('provider/setReviewMax', true)
        }

        if (res.list.length) {
          for (let i = 0; i < res.list.length; i++) {
            VueApp.$store.commit('provider/addReviews', {
              id: res.list[i].id,
              name: res.list[i].name,
              consumerId: res.list[i].consumerId,
              message: res.list[i].message,
              value: res.list[i].value,
              created: moment(res.list[i].created, 'YYYY-MM-DD@HH:mm').format('MM/DD/YYYY ' + ft.timeFormat(VueApp, false))
            })
          }
        }
      }
      callback(res)
    })
  }
}



// WEBPACK FOOTER //
// ./src/modules/api/provider/reviews.js